import DotElement from '../DotElement.vue';
export default {
  name: "RangeBar",
  components: {
    DotElement
  },
  props: {
    values: {
      type: Object,
      default: () => []
    },
    color: {
      type: String,
      default: "#FFD6E8"
    },
    range_min: {
      type: Number,
      default: 0
    },
    range_max: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 4
    }
  },
  computed: {
    rangePositionAndWidth() {
      const rangePosition = ((this.range_min - this.min) / (this.max - this.min)).toFixed(1) * 100;
      const rangeWidth = ((this.range_max - this.range_min) / (this.max - this.min)).toFixed(1) * 100;
      return {
        rangePosition,
        rangeWidth
      };
    }
  },
  methods: {
    getValuePosition(value) {
      return (value - this.min < 0 ? 0 : value - this.min) / (this.max - this.min) * 100;
    }
  }
};